import React, { useState } from 'react';
import ContractForm from './ContractForm';
import ContractPreview from './ContractPreview';

function GenerateContract() {
  const [formData, setFormData] = useState({
    contractNumber: '',
    serviceProviderName: '',
    serviceProviderAddress: '',
    serviceProviderEmail: '',
    customerName: '',
    customerAddress: '',
    customerEmail: '',
    effectiveDate: '',
    totalAmount: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="flex flex-wrap justify-center mt-16">
      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-2xl font-bold mb-4">Contract Details</h2>
        <ContractForm formData={formData} handleChange={handleChange} />
      </div>
      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-2xl font-bold mb-4">Contract Preview</h2>
        <ContractPreview formData={formData} />
      </div>
    </div>
  );
}

export default GenerateContract;
